<template>
  <card :item="item" :type="type">
    <div class="cardbody" @click.stop="goDetails(item)">
      <div class="header">
        <div class="left">
          <img v-if="item.avatarAddress&&item.avatarAddress.includes('myhuaweicloud')" style="object-fit:cover" :src="item.avatarAddress" alt />
          <img v-else-if="item.teamType == 1" src="@/assets/public/team-logo.png" alt/>
          <img v-else-if="item.teamType == 0" src="@/assets/public/shigongdui60.png" alt />
          <span v-if="showIndex">
            <img v-if="index<6" :src="require(`@/assets/popularity/no${index+1}.png`)" class="ranking">
          </span>
        </div>
        <div class="right">
          <img class="buildStatus" v-if="item.buildStatus== 0" src="@/assets/team/shigongzhong.png" alt/>
          <img class="buildStatus" v-else-if="item.buildStatus == 1" src="@/assets/team/keyichugong.png" alt/>
          <!-- row1 -->
          <div class="item_title">
            {{ item.teamName}}
          </div>
          <!-- row2 -->
          <div style="height:20px;line-height:20px;margin-top:8px">
            <span class="tagItem">
              {{item.teamTypeName}}
            </span>
            <span class="tagItem" v-if="item.teamNumber&&!Number(item.teamSize)">
              团队人数：{{item.teamNumber}}
            </span>
            <span class="tagItem" v-else-if="!item.teamNumber&&Number(item.teamSize)">
              团队人数：{{item.teamSize+'人'}}
            </span>
            <span class="tagItem" v-if="item.teamNumber&&Number(item.teamSize)">
              团队人数：{{item.teamSize+'人'}}
            </span>
            <span class="tagItem" v-if="item.contact">
              负责人：{{ item.contact }}
            </span>
          </div>
        </div>
      </div>     
      <div class="content">
        <el-row :gutter="20">
          <el-col :span="12" class="single_hide contents">
            <span class="color6">施工专业:</span>
            <span :title="item.category" class="color3">{{item.category |formattingEngineering}}</span>
          </el-col>
          <el-col v-if="item.teamType == 0" :span="12" class="single_hide contents">
            <span class="color6">资质名称:</span>
            <span :title="item.qualificationsName" class="color3">{{item.qualificationsName ||'/'}}</span>
          </el-col>
          <el-col v-if="item.teamType == 0" :span="12" class="single_hide contents">
            <span class="color6">专项资产:</span>
            <span :title="item.equName" class="color3">{{item.equName ||'/'}}</span>
          </el-col>
          <el-col v-if="item.teamType == 1" :span="12" class="single_hide contents">
            <span class="color6">自有设备:</span>
            <span :title="item.equName" class="color3">{{item.equName|| "/"}}</span>
          </el-col>
          <el-col :span="12" class="single_hide contents">
            <span class="color6">工作区域:</span>
            <span :title="item.serviceAreaName" class="color3">{{item.serviceAreaName|formattingEngineering}}</span>
          </el-col>
        </el-row>
        <!-- <div>
          <span class="color6">隶属单位:</span>
          <span class="color3" v-if="item.teamType == 0">{{item.legalComName || '/'}}</span>
          <span class="color3" v-if="item.teamType == 1">{{hasAffCom?item.affiliatedUnitPic :'暂无隶属单位'}}</span>
        </div> -->
      </div>
    </div>
    <div class="address">
      <img src="@/assets/team/locationIcon.png" />
      <span v-if="item.teamType == 0" style="color: #666666; margin-left: 5px">工队所在地:</span>
      <span v-if="item.teamType == 1" style="color: #666666; margin-left: 5px">班组所在地:</span>
      <span style="color: #666666;display:inline-block">{{item.address?item.address:"-"}}</span>
      <span v-if="item.updateTime===item.createTime" class="createTime color6">{{item.createTime | formatDate}}发布</span>
      <span v-else class="createTime color6">{{item.updateTime | formatDate}}更新</span>
    </div>
  </card>
</template>

<script>
import {checkDataStatusMessage} from "@/utils/checkDataStatus"
export default {
  name: "cardTeam",
  components: {
    card: () => import("@/components/card/card"),
  },
  inject:['cardListCom'],
  data() {
    return {}
  },
  props: {
    item:Object,
    type: Number, // 1 工队 2 工程 3 工人 4 临时用工 5 工种报价 6劳务用工
    showIndex:{
      type:Boolean,
      default:true
    },
    index: Number, // 排名
    cardType:{//卡片类型 1 工程工队 2 人气工队
      type:[Number,String],
      default:1
    }
  },
  methods:{
    //跳转详细
    async goDetails(item) {
      let type=await checkDataStatusMessage.call(this,this.type,item.no);
      if(type!=1){return;}
      // 1企业 0 个人
      let query = {}
      if (item.isCompany === 1 && item.teamType === 0) {
        query = {
          companyNo: item.companyNo,
          teamNo: item.no
        }
      } else {
        query = {
          userNo: item.userNo,
          teamNo: item.no
        }
      }
      let routeUrlC = `${this.cardType==1?"/ConstructionTeamDetail":"/popularityTeamDetail"}?userNo=${item.userNo}&teamNo=${item.no}&companyNo=${item.companyNo}`
      window.open(routeUrlC, "_blank")
      /*this.$router.push({
        path: this.cardType==1?"./ConstructionTeamDetail":"./popularityTeamDetail",
        query: query
      })*/
    },
  },
  computed:{
    hasAffCom(){
      if(this.item.companyNo){
        // 公司发布
        return this.item.affiliatedUnitPic && !this.item.affiliatedUnitPic.startsWith('http')
      }else {
        // 个人发布
        return this.item.affiliatedStatus==2 && !this.item.affiliatedUnitPic.startsWith('http')
      }
    }
  },
}
</script>

<style lang="scss" scoped>
    .single_hide {
      // 单行隐藏
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
.cardbody{
  padding:10px 15px 10px 10px;
  line-height: 23px;
  .header{
    height: 60px;
    .left{
      display: inline-block;
      width: 60px;
      height: 60px;
      img{
        width: 60px;
        height: 60px;
        border: 1px solid #e4e7ed;
        border-radius: 10px;
      }
      span{
        position: relative;
      }
      .ranking{
        width: 36px;
        height: 20px;
        position: absolute;
        border:none;
        top: -75px;
        right: -70px;
      }
    }
    .right{
      margin-left: 10px;
      display: inline-block;
      width: calc(100% - 85px);
      line-height: 24px;
      position: relative;
      top: -13px;
      font-size: 16px;
      .buildStatus{
        position: absolute;
        right: -30px;
        top: -15px;
        width: 70px;
        height: 70px;
      }
      .item_title{
        max-width: 450px;
        margin-right: 15px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: 20px;
        line-height: 20px;
      }
      .tagItem{
        height: 20px;
        line-height: 20px;
        display: inline-block;
        margin-right: 5px;
        padding: 0 5px;
        background: rgba(2, 134, 223, 0.1);
        color: #409ee9;
        font-size: 12px;
      }
    }
  }
  .content{
    >div{
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .contents{
      height: 19px;
      line-height: 19px;
      margin-top: 10px;
    }
  }
}
.address{
  position: relative;
  height: 34px;
  line-height: 34px;
  padding-left: 10px;
  border-top: 1px dashed #e4e7ed;
  img{
    vertical-align: middle;
    margin-top: -4px;
  }
  .createTime{
        position: absolute;
        right: 15px;
    }
}
div {
  box-sizing: border-box;
}
.color6 {
  color: #666666;
}
.color3 {
  color: #333333;
}
</style>
